import { useTranslation } from "react-i18next";
import type { BlockingFieldError } from "../hooks/use-tellescope-enduser-form";
import { FormBlockingError } from "./FormBlockingError";

export interface FormBlockingErrorsProps {
  blockingErrors: BlockingFieldError[];
  onSelectField: (fieldId: string) => void;
}

/** The validation errors holding the Submit button disabled, listed on the wizard's final page. */
export const FormBlockingErrors = ({ blockingErrors, onSelectField }: FormBlockingErrorsProps) => {
  const { t } = useTranslation("forms");

  if (blockingErrors.length === 0) return null;

  return (
    <div role="alert" className="flex flex-col gap-1 rounded-md border border-destructive p-3">
      <p className="text-sm font-medium text-destructive">{t("Please fix the following before submitting:")}</p>
      {blockingErrors.map((blockingError) => (
        <FormBlockingError key={blockingError.fieldId} blockingError={blockingError} onSelectField={onSelectField} />
      ))}
    </div>
  );
};
